import {DatasetChartProps} from "components/dashboard/charts/interfaces";

export const defaultLoadConf = {
    lead: 0,
    lag: 6,
    leadUnit: "HOURS",
    lagUnit: "HOURS",
    alignUnit: null,
};

export const defaultDatasetLineChartConfig: DatasetChartProps = {
    identifiers: [],
    height: undefined,
    showDateSelection: true,
    hideRefresh: false,
    loadConf: defaultLoadConf,
    updateFrequency: 5,
    datasets: [],
    toggleTracesGrouping: false,
    timeAxisStepSeconds: 0,
};
